<template>
  <div class="overflow-hidden modal">
    <!-- overlay -->
    <transition
      name="overlay"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >

      <portal to="overlay">
        <div class="fixed pin z-20" v-if="isModalVisible">
          <div
            @click="hideModal()"
            class="absolute pin bg-black opacity-25"></div>
        </div>
      </portal>
    </transition>
    <!-- end overlay -->

    <transition
      name="paths"
      leave-active-class="animated fadeOut faster"
      enter-active-class="animated fadeIn faster"
    >

      <portal to="modal">
        <div v-if="isModalVisible"
          class="fixed pin flex modal overflow-auto z-40">
          <div
            class="relative bg-gray-lightest w-full flex-col flex overflow-auto p-8">

            <div class="container mx-auto">
              <div class="lg:w-1/2 m-auto">

                <div @click="goBack()"
                  class="text-xs cursor-pointer underline text-full-blue"
                >Back</div>

                <div class="flex justify-between items-center pb-6">
                  <h2 class="text-2xl py-4 font-bold">Verify Connection</h2>
                </div>

                <div class="container">
                  <div class="pb-8">
                    <form @submit.prevent="verifyConnection">
                      <div class="mb-4">
                        <label class="block mb-2">Verification Code</label>
                        <input
                          v-model="code"
                          class="block appearance-none border border-white bg-white text-grey-darker py-1 px-2 rounded-l focus:outline-none focus:bg-white focus:border-grey" />
                        <p v-if="error" class="mt-2 text-red text-sm">{{error}}</p>
                      </div>
                      <div class="flex justify-end items-center">
                        <div class="cursor-pointer mr-4" @click="hideModal()">
                          Cancel
                        </div>
                        <t-button
                          type="submit"
                        >Verify</t-button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </portal>
    </transition>
  </div>
</template>

<script>
 import {parsePhoneNumberFromString} from 'libphonenumber-js'
 import api from '@/api'

 export default {
   name: 'verify-connection-modal',

   props: {
     isModalVisible: {
       type: Boolean,
       default: true
     },
     connection: {
       type: Object,
       required: true
     }
   },

   data () {
     return {
       code: '',
       error: ''
     }
   },

   methods: {
     hideModal () {
       this.code = ''
       this.error = ''
       this.$emit('close');
       this.$emit('complete');
     },

     goBack() {
       this.hideModal()
     },

     async verifyConnection () {
       const {res, err} = await api.verifyConnection(this.connection.id, this.code);

       if (err || res.success === false) {
         this.error = `That didn't work, try again. If the problem persists, contact support: hello@tatatap.com`
         return;
       }

       this.$toasted.show(`Connection Verified.`, {duration: 3000})

       this.$emit('complete', res)
       this.$emit('close')
     }
   },
 }
</script>
